export const digitToString = {
  1: '_one',
  2: '_two',
  3: '_three',
};
